import { c as _c } from "react/compiler-runtime";
/** The sentence the grouping wrote for the group, under its name in the guide and the card. */
export function PrV2GroupDescription(t0) {
  const $ = _c(2);
  const {
    groupNameReason
  } = t0;
  if (!groupNameReason) {
    return null;
  }
  let t1;
  if ($[0] !== groupNameReason) {
    t1 = <p className="text-[13px] leading-relaxed text-zinc-300">{groupNameReason}</p>;
    $[0] = groupNameReason;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}